import { Link as RLink } from "react-router-dom";

import MUIBreadcrumbs from "@mui/material/Breadcrumbs";
import Tooltip from "@mui/material/Tooltip";
import HomeIcon from "@mui/icons-material/Home";
import Groups2Icon from "@mui/icons-material/Groups2";
import AppsIcon from "@mui/icons-material/Apps";
import CalculateIcon from "@mui/icons-material/Calculate";
import GirlIcon from "@mui/icons-material/Girl";
import Link from "@mui/material/Link";

import { useAttendanceContext } from "../../contexts/AttendanceContext";

import "./breadcrumbs.css";

const ICON_MAP: Record<string, React.ReactNode> = {
  HomeIcon: <HomeIcon sx={{ fontSize: "inherit" }} />,
  Groups2Icon: <Groups2Icon sx={{ fontSize: "inherit" }} />,
  AppsIcon: <AppsIcon sx={{ fontSize: "inherit" }} />,
  CalculateIcon: <CalculateIcon sx={{ fontSize: "inherit" }} />,
  GirlIcon: <GirlIcon />,
};

function Breadcrumbs() {
  const attendance = useAttendanceContext();
  const breadcrumbs = attendance.breadcrumbs;

  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <MUIBreadcrumbs className="breadcrumbs" aria-label="breadcrumb" separator="›">
      {breadcrumbs.map(({ label = "", path, icon: iconKey }, index) => {
        const last = index === breadcrumbs?.length - 1;
        const icon = ICON_MAP[iconKey] || <Groups2Icon sx={{ fontSize: "inherit" }} />;

        return last ? (
          <Tooltip key={label} title={label} arrow placement="bottom">
            <span className="bc-current">
              <span className="bc-icon">{icon}</span>
              <span className="bc-label">{label}</span>
            </span>
          </Tooltip>
        ) : (
          <RLink
            key={label}
            to={path}
            state={{
              breadcrumbs: [...(breadcrumbs?.slice(0, index + 1) || [])],
            }}
          >
            <Tooltip title={label} arrow placement="bottom">
              <Link underline="hover" className="cursor-pointer bc-link">
                <span className="bc-icon">{icon}</span>
                <span className="bc-label">{label}</span>
              </Link>
            </Tooltip>
          </RLink>
        );
      })}
    </MUIBreadcrumbs>
  );
}

export default Breadcrumbs;
